module.exports = __webpack_public_path__ + "static/media/GLPic.bd734472.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/App/Media/GLPic.png
// module id = 200
// module chunks = 0